export var DeviceIconState;
(function (DeviceIconState) {
    DeviceIconState["no_service"] = "no-service";
    DeviceIconState["not_on_operation"] = "not-on-operation";
    DeviceIconState["malfunction"] = "malfunction";
    DeviceIconState["alarm"] = "alarm";
    DeviceIconState["guard_zone_alarm"] = "guard-zone-alarm";
    DeviceIconState["sensor_alarm"] = "sensor_alarm";
    DeviceIconState["offline"] = "offline";
    DeviceIconState["offline_ride"] = "offline-ride";
    DeviceIconState["offline_parking"] = "offline-parking";
    DeviceIconState["online"] = "online";
    DeviceIconState["online_ride"] = "online-ride";
    DeviceIconState["online_parking"] = "online-parking";
    DeviceIconState["guard_on"] = "guard-on";
    DeviceIconState["guard_enabling"] = "guard-enabling";
    DeviceIconState["guard_off"] = "guard-off";
    DeviceIconState["guard_off_silent"] = "guard-off-silent";
})(DeviceIconState || (DeviceIconState = {}));
